import { APIError } from "../http/http";

export function toLoggableError(error: Error | unknown) {
  if (error instanceof APIError) {
    return {
      name: error.name,
      errorMessage: error.message,
      statusCode: error.response.status,
      data: error.data,
    };
  }

  return error;
}
